import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError, finalize, throwError } from 'rxjs';
import { WidgetMessageService } from '../services/widget-message.service';
import { environment } from '../../../environments/environment';
import { SpinnerService } from '../spinner/service/spinner.service';
import { AuthState } from '../authentication/auth.state';
import { LogoutAction } from '../authentication/auth.state.model';

export const IS_INTERCEPTING_ENABLED = new HttpContextToken<boolean>(() => true);

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const store = inject(Store);
  const spinnerService = inject(SpinnerService);
  const widgetService = inject(WidgetMessageService);

  const token = store.selectSnapshot(AuthState.getToken);

  if (!req.context.get(IS_INTERCEPTING_ENABLED)) {
    return next(req);
  }

  const handleError = (error: HttpErrorResponse) => {
    spinnerService.hide();

    if (error.status === 401) {
      console.error('Unauthorized request:', error);

      const isLogoutRequest = req.url.includes('/logout');

      if (isLogoutRequest) {
        router.navigate(['login']);
      }
      else {
        store.dispatch(new LogoutAction());
      }

      return throwError(() => error);
    }

    if (environment.isProd) {
      widgetService.setMessage({
        message: `Anfrage mit Fehlercode ${error.status} fehlgeschlagen`,
        messageTye: 'mtError'
      });
    }
    else {
      widgetService.setMessage({
        code: error.status,
        message: error.message,
        messageTye: 'mtError'
      });
    }

    return throwError(() => error);
  };

  const finalizeRequest = () => {
    spinnerService.hide(); // Hide spinner at the end of the request
  };

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return next(authReq).pipe(
      catchError(handleError),
      finalize(finalizeRequest) // Ensure finalize is called after every request
    );
  }
  else {
    spinnerService.hide(); // Hide the spinner if no token is present
    return next(req).pipe(
      catchError(handleError)
    );
  }
};
